
  <div class="page-breadcrumb">
    <div class="row">
      <div class="col-7 align-self-center">
        <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">Subject Management
        </h3>

        <div class="d-flex align-items-center">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb m-0 p-0">
              <li class="breadcrumb-item"><a></a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="col-5 align-self-center">
      </div>
    </div>
  </div>

  <body id="page-top">
    <div id="wrapper">
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <div class="container-fluid px-4">
            <p class=""></p>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h4 class="m-0 font-weight-bold text-primary">Subject Management</h4>
                <div class="">

                  <a data-toggle="modal" data-target="#create-factor-modal" [routerLink]="['/routePath']"
                    class="d-sm-inline btn btn-sm btn-primary shadow-sm"><i class="fa fa-plus fa-sm text-white-50"></i>
                    Create Subject</a>
                </div>
              </div>

              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" datatable
                    [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                    <thead>
                      <tr>
                        <th>Subject Name</th>
                        <th>Classroom</th>
                        <th>Department</th>
                        <th>Subject Incharge</th>
                        <th>Options</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>Subject Name</th>
                        <th>Classroom</th>
                        <th>Department</th>
                        <th>Subject Incharge</th>
                        <th>Options</th>
                      </tr>
                    </tfoot>

                    <!-- Start of DataTable -->
                    <tbody>
                      <tr *ngFor="let factor of Factors">
                        <td (click)=toSubDetail(factor)>{{factor.subject_code}} - {{factor.subject_name}}</td>
                        <td>{{factor.classroom_name}}</td>
                        <td>{{factor.department_name}}</td>
                        <td>{{factor.subject_incharge}}</td>
                        <td style="cursor: pointer;" align="center" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="fa fa-ellipsis-h " aria-hidden="true"></i>
                          <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                            <a class="dropdown-item" (click)=toSubDetail(factor)>Subject Detail</a>
                            <a class="dropdown-item" (click)="show_edit(factor)">Edit Subject</a>
                            <a class="dropdown-item text-danger" (click)="delete_factor(factor)">Delete Subject</a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <!-- End of DataTable -->



                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </body>




  <!-- Create  Factor modal content -->
  <div id="create-factor-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <!-- <<  Customer - Factor -   >> -->
          <form #formValues1="ngForm" (ngSubmit)="create_factor(formValues1)" class="pl-3 pr-3">

            <!-- Subject Name - subject_name - text - required -->
            <div class="form-group">
              <label>Subject Name</label>
              <input class="form-control" [(ngModel)]="Factor.subject_name" name="subject_name" #subject_name="ngModel"
                type="text" placeholder="Enter Subject Name" required>
              <div class="error" *ngIf="subject_name.touched && !subject_name.valid"> faculty
                mail is
                required</div>
            </div>
            <!-- End of Subject Name -->

            <!-- Subject Code - subject_code - text - required -->
            <div class="form-group">
              <label>Subject Code</label>
              <input class="form-control" [(ngModel)]="Factor.subject_code" name="subject_code" #subject_code="ngModel"
                type="text" placeholder="Enter Subject Code" required>
              <div class="error" *ngIf="subject_code.touched && !subject_code.valid"> subject_code
                is
                required</div>
            </div>
            <!-- End of Subject Code -->

            <!-- Classrooms - form - [ department_name - department_id ] - ng-select - selectedClassrooms -->
            <div class="form-group">
              <label>Classrooms</label>
              <ng-select [items]="Classrooms" bindLabel="classroom_name" autofocus bindValue="classroom_id"
                [(ngModel)]="Factor.classroom" name="factor" placeholder="Select Classrooms">
              </ng-select>
            </div>
            <!-- End of Select Faculty -->

            <!-- Faculty - form - [ username - faculty_id ] - ng-select - selectedFaculty -->
            <div class="form-group">
              <label>Faculty</label>
              <ng-select [items]="Faculties" bindLabel="username" autofocus bindValue="faculty_id"
                [(ngModel)]="Factor.incharge" name="factor" placeholder="Select Faculty">
              </ng-select>
            </div>
            <!-- End of Select Faculty -->


            <div class="form-group text-center">
              <button class="btn btn-primary" type="submit">Create Subject</button>
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>
  <!-- End of Create Factor -->



  <!-- Edit  Factor modal content -->
  <div id="edit-factor-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <form #formValues2="ngForm" (ngSubmit)="edit_factor(formValues2)" class="pl-3 pr-3">

            <!-- Company name - company_name - text - required -->
            <div class="form-group">
              <label>Company name</label>
              <input class="form-control" [(ngModel)]="Factor.company_name" name="company_name" #company_name="ngModel"
                type="text" placeholder="Enter Company name" required>
              <div class="error" *ngIf="company_name.touched && !company_name.valid"> Company
                name is
                required</div>
            </div>
            <!-- End of Company name -->

            <!-- Contact Person - customer_name - text - required -->
            <div class="form-group">
              <label>Contact Person</label>
              <input class="form-control" [(ngModel)]="Factor.customer_name" name="customer_name"
                #customer_name="ngModel" type="text" placeholder="Enter Contact Person" required>
              <div class="error" *ngIf="customer_name.touched && !customer_name.valid"> Contact
                Person is
                required</div>
            </div>
            <!-- End of Contact Person -->

            <div class="form-group text-center">
              <button (click)=delete_factor(Factor) class="btn btn-light">Delete</button>
              <button class="btn btn-primary" type="submit">Update Customer</button>
            </div>


          </form>

        </div>
      </div>
    </div>
  </div>
  <!-- End of Edit Factor -->
